import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import RichTextEditor from "react-rte";
import { Button } from "reactstrap";
import moment from "moment";
import { API_END_POINT } from "../config";
import Cookie from "js-cookie";
const token = Cookie.get("waffle_world_access_token");

import { DateRangePicker } from "react-dates";
import "react-dates/initialize";

import Select from "react-select";
import "react-select/dist/react-select.css";
import { JWT_SECRET_TOKEN } from "../config";
const jwt = require("jsonwebtoken");

export default class GalleryForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      banner: {
        name: "",
        desktopImage: "",
        tabletImage: "",
        mobileImage: "",
        bannerType: "",
      },
      products: [],
      product: "",
      specialOffers: [],
      specialOffer: "",
      categories: [],
      category: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.postCoverBanner = this.postCoverBanner.bind(this);
  }

  componentDidMount() {
    console.log("props", this.props);
    const { match } = this.props;
    if (match.params.bannerId) {
      axios
        .get(`${API_END_POINT}/api/banners/one`, {
          params: { bannerId: match.params.bannerId },
          headers: { "auth-token": token },
        })
        .then((response) => {
          this.setState(
            {
              banner: response.data.object[0],
            },
            () => {
              let { banner } = this.state;
              delete banner["desktopImage"];
              delete banner["tabletImage"];
              delete banner["mobileImage"];
              if (this.state.banner.productId) {
                axios
                  .get(`${API_END_POINT}/api/items/one`, {
                    params: { itemId: this.state.banner.productId },
                    headers: { "auth-token": token },
                  })
                  .then((response) => {
                    this.setState({
                      product: response.data.object[0],
                    });
                  });
              } else if (this.state.banner.categoryId) {
                axios
                  .get(`${API_END_POINT}/api/categories/one`, {
                    params: { categoryId: this.state.banner.categoryId },
                  })
                  .then((response) => {
                    this.setState({
                      category: response.data.object[0],
                    });
                  });
              } else if (this.state.banner.specialOfferId) {
                axios
                  .get(`${API_END_POINT}/api/items/one`, {
                    params: { itemId: this.state.banner.specialOfferId },
                    headers: { "auth-token": token },
                  })
                  .then((response) => {
                    this.setState({
                      specialOffer: response.data.object[0],
                    });
                  });
              }
            }
          );
        });
    }
  }

  fetchProducts = () => {
    axios
      .get(`${API_END_POINT}/api/items`, { headers: { "auth-token": token } })
      .then((response) => {
        this.setState({
          products: response.data.objects,
        });
      })
      .catch((err) => {
        window.alert("ERROR FETCHING PRODUCTS");
      });
  };

  fetchCategories = () => {
    axios
      .get(`${API_END_POINT}/api/categories`)
      .then((response) => {
        this.setState({
          categories: response.data.objects,
        });
      })
      .catch((err) => {
        window.alert("ERROR FETCHING CATEGORIES");
      });
  };

  fetchSpecialOffers = () => {
    axios
      .get(`${API_END_POINT}/api/items/specialOffer`)
      .then((response) => {
        this.setState({
          specialOffers: response.data.object,
        });
      })
      .catch((err) => {
        window.alert("ERROR FETCHING SPECIAL OFFERS");
      });
  };

  setHotel(selectedHotel) {
    this.setState((prevState) => ({
      hotel: selectedHotel,
      banner: {
        ...prevState.banner,
        hotel_id: selectedHotel.ID,
      },
    }));
  }

  setDescription(description) {
    const { banner } = this.state;
    banner.description = description.toString("html");
    this.setState({
      banner,
      description,
    });
  }

  handleInputChange(event) {
    const { value, name } = event.target;

    const { banner } = this.state;
    banner[name] = value;
    this.setState({ banner });

    if (name === "bannerType") {
      if (value === "item") {
        delete banner["categoryId"];
        delete banner["specialOfferId"];
        this.fetchProducts();
      } else if (value === "category") {
        delete banner["productId"];
        delete banner["specialOfferId"];
        this.fetchCategories();
      } else if (value === "specialOffer") {
        delete banner["categoryId"];
        delete banner["productId"];
        this.fetchSpecialOffers();
      }
    }
  }

  handleImages = (event) => {
    const { name } = event.target;
    const { banner } = this.state;
    banner[name] = event.target.files[0];
    this.setState({ banner });
  };

  postCoverBanner(event) {
    event.preventDefault();
    const { match, history } = this.props;
    const { loading, banner } = this.state;
    this.setState({ loading: true });

    const fd = new FormData();
    Object.keys(banner).forEach((eachState) => {
      fd.append(`${eachState}`, banner[eachState]);
    });

    if (match.params.bannerId) {
      banner.bannerId = match.params.bannerId;
      delete banner["_id"];
      delete banner["userId"];
      delete banner["date"];
      delete banner["__v"];
      this.setState({ banner });
      const fd = new FormData();
      Object.keys(banner).forEach((eachState) => {
        fd.append(`${eachState}`, banner[eachState]);
      });
      const tokenx = jwt.sign({ payload: requestParams }, JWT_SECRET_TOKEN, {
        expiresIn: "1h",
      });
      axios
        .post(`${API_END_POINT}/api/banners/update`, fd, {
          headers: { "auth-token": tokenx },
        })
        .then((response) => {
          if (response.status === 200) {
            window.alert(response.data.message);
            this.setState({ loading: false });
            this.props.history.goBack();
          } else {
            window.alert("ERROR");
            this.setState({ loading: false });
          }
        });
    } else {
      const tokenx = jwt.sign({ payload: fd }, JWT_SECRET_TOKEN, {
        expiresIn: "1h",
      });
      axios
        .post(`${API_END_POINT}/api/banners`, fd, {
          headers: { "auth-token": tokenx },
        })
        .then((response) => {
          if (response.status === 200) {
            window.alert(response.data.msg);
            this.setState({ loading: false });
            this.props.history.goBack();
          } else {
            window.alert("ERROR");
            this.setState({ loading: false });
          }
        })
        .catch((err) => {
          this.setState({ loading: false });
        });
    }
  }

  setProduct(selectedProduct) {
    this.setState((prevState) => ({
      product: selectedProduct,
      banner: {
        ...prevState.banner,
        productId: selectedProduct._id,
      },
    }));
  }

  setCategory(selectedCategory) {
    this.setState((prevState) => ({
      category: selectedCategory,
      banner: {
        ...prevState.banner,
        categoryId: selectedCategory._id,
      },
    }));
  }

  setSpecialOffer(selectedSpecialOffer) {
    this.setState((prevState) => ({
      specialOffer: selectedSpecialOffer,
      banner: {
        ...prevState.banner,
        specialOfferId: selectedSpecialOffer._id,
      },
    }));
  }

  render() {
    const {
      loading,
      banner,
      product,
      products,
      specialOffer,
      specialOffers,
      category,
      categories,
    } = this.state;
    console.log(this.state);

    return (
      <div className="row animated fadeIn">
        <div className="col-12">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="x_panel">
                <div className="x_title">
                  <h2>Enter Banner Details</h2>
                </div>
                <div className="x_content">
                  <br />
                  <form
                    id="demo-form2"
                    data-parsley-validate
                    className="form-horizontal form-label-left"
                    onSubmit={this.postCoverBanner}
                  >
                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Name
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="name"
                          className="form-control"
                          value={banner.name}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Banner Typ
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <select
                          name="bannerType"
                          value={banner.bannerType}
                          className="form-control"
                          onChange={this.handleInputChange}
                          required
                        >
                          <option value="">Select Value</option>
                          <option value="item">Item</option>
                          <option value="category">Category</option>
                          <option value="specialOffer">Special Offer</option>
                        </select>
                      </div>
                    </div>

                    {banner.bannerType === "item" && (
                      <div className="form-group row">
                        <label className="control-label col-md-3 col-sm-3">
                          Produkt
                        </label>
                        <div className="col-md-6 col-sm-6">
                          <Select
                            name="productId"
                            value={product}
                            onChange={(value) => this.setProduct(value)}
                            options={products}
                            valueKey="_id"
                            labelKey="name"
                            clearable={false}
                            backspaceRemoves={false}
                            required
                          />
                        </div>
                      </div>
                    )}

                    {banner.bannerType === "category" && (
                      <div className="form-group row">
                        <label className="control-label col-md-3 col-sm-3">
                          Kategorie
                        </label>
                        <div className="col-md-6 col-sm-6">
                          <Select
                            name="productId"
                            value={category}
                            onChange={(value) => this.setCategory(value)}
                            options={categories}
                            valueKey="_id"
                            labelKey="name"
                            clearable={false}
                            backspaceRemoves={false}
                            required
                          />
                        </div>
                      </div>
                    )}

                    {banner.bannerType === "specialOffer" && (
                      <div className="form-group row">
                        <label className="control-label col-md-3 col-sm-3">
                          Angebot
                        </label>
                        <div className="col-md-6 col-sm-6">
                          <Select
                            name="productId"
                            value={specialOffer}
                            onChange={(value) => this.setSpecialOffer(value)}
                            options={specialOffers}
                            valueKey="_id"
                            labelKey="name"
                            clearable={false}
                            backspaceRemoves={false}
                            required
                          />
                        </div>
                      </div>
                    )}

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Desktop Banner (Benötigte Auflösung = 1450 x 365)
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          type="file"
                          accept="image/*"
                          name="desktopImage"
                          className="form-control"
                          onChange={this.handleImages}
                          // multiple
                          required={
                            this.props.match.params.bannerId ? false : true
                          }
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Tablet Banner (Benötigte Auflösung = 768 x 365)
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          type="file"
                          accept="image/*"
                          name="tabletImage"
                          className="form-control"
                          onChange={this.handleImages}
                          // multiple
                          required={
                            this.props.match.params.bannerId ? false : true
                          }
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Mobile Banner (Benötigte Auflösung = 300 X 250)
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          type="file"
                          accept="image/*"
                          name="mobileImage"
                          className="form-control"
                          onChange={this.handleImages}
                          // multiple
                          required={
                            this.props.match.params.bannerId ? false : true
                          }
                        />
                      </div>
                    </div>

                    <div className="ln_solid" />
                    <div className="form-group row">
                      <div className="col-md-6 col-sm-6 offset-md-3">
                        <Button
                          className={`btn btn-success btn-lg ${
                            this.state.loading ? "disabled" : ""
                          }`}
                        >
                          <i
                            className={`fa fa-spinner fa-pulse ${
                              this.state.loading ? "" : "d-none"
                            }`}
                          />{" "}
                          Bestätigen
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/BannerForm.jsx